.sectionTitle {
    display: block;
    margin-bottom: var(--spacer-24);
    color: var(--gray-700);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.linkList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
    margin-bottom: var(--mobile-submenu-gap);
}

.link {
    display: block;
    font: var(--font-nav-16);
}
